import { isLocalOrPreviewEnv } from '../isLocalOrPreviewEnv/isLocalOrPreviewEnv';

const isClient = typeof window !== 'undefined';

export const getApiUrl = () =>
  isClient && isLocalOrPreviewEnv()
    ? `${window.location.origin}/api/v1`
    : process.env.NEXT_PUBLIC_GQL_API_ENDPOINT_URL;
